import { Box } from '@chakra-ui/react'
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis,
  CartesianGrid, Tooltip, ReferenceLine, Cell
} from 'recharts'
import { PointData } from '../../hooks/useProcessedPointData'
import { getHexFromColor } from '../../utils/colors'

interface PointGraphProps {
  data: PointData[]
  team1Color: string
  team2Color: string
  superTiebreakSets?: number[] // Array of set indices (0-based) that were Super Tie-breaks
}

export function PointGraph({ data, team1Color, team2Color, superTiebreakSets = [] }: PointGraphProps) {
  return (
    <Box width="100%" height="400px">
      <ResponsiveContainer>
        <BarChart
          data={data}
          margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
        >
          <defs>
            <linearGradient id="setBoundary" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="rgba(255, 255, 255, 0.1)" />
              <stop offset="100%" stopColor="rgba(255, 255, 255, 0.05)" />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#09090b" />
          <XAxis
            dataKey="point"
            stroke="white"
            tick={{ fill: 'white' }}
            axisLine={{ stroke: '#444' }}
            tickLine={{ stroke: '#444' }}
            dy={16}
          />
          <YAxis
            orientation="left"
            stroke="white"
            tick={{ fill: 'white' }}
            tickFormatter={(value: number) => Math.round(value).toString()}
            allowDecimals={false}
            domain={[-3, 3]}
            axisLine={{ stroke: '#444' }}
            tickLine={{ stroke: '#444' }}
          />
          <YAxis
            orientation="right"
            stroke="white"
            tick={{ fill: 'white' }}
            tickFormatter={(value: number) => Math.round(value).toString()}
            allowDecimals={false}
            domain={[-3, 3]}
            axisLine={{ stroke: '#444' }}
            tickLine={{ stroke: '#444' }}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: '#09090b',
              border: '1px solid #444',
              color: 'white'
            }}
            formatter={(value: number) => [Math.abs(value), 'Points']}
          />
          <ReferenceLine y={0} stroke="#444" />
          <Bar dataKey="cumulative">
            {data.map((entry, index) => {
              // Check if this point is in a Super Tie-break set
              const isInSuperTiebreakSet = entry.setIndex !== undefined && superTiebreakSets.includes(entry.setIndex);
              
              // For Super Tie-breaks, only apply opacity to the final point, not points 7-9
              const shouldApplyOpacity = entry.isLastPointInSet || entry.isLastPointInGame || 
                (isInSuperTiebreakSet && entry.point >= 10); // Only apply to points 10+ in Super Tie-breaks
              
              return (
                <Cell
                  key={index}
                  fill={getHexFromColor(entry.color)}
                  stroke={getHexFromColor(entry.color)}
                  fillOpacity={shouldApplyOpacity ? 0.2 : 1}
                />
              );
            })}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Box>
  )
} 